module.exports = __webpack_public_path__ + "static/image-03-a@2x-214a5cf6de6f727574638d155464b9c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/designmuseum/image-03-a@2x.jpg
// module id = 367
// module chunks = 3627797113349 20562973939449 33019919093843